import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';

interface LoadingStateProps {
  loadingText: string;
  progress: {
    current: number;
    total: number;
  } | null;
}

export function LoadingState({ loadingText, progress }: LoadingStateProps) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <div className="flex items-center text-sm text-indigo-600">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Loading Dataset
        </div>
      </div>

      <div className="bg-white shadow-lg rounded-lg p-8">
        <h2 className="text-lg font-medium text-gray-900 mb-6">
          Generating Dataset
        </h2>
        <div className="flex flex-col items-center justify-center space-y-4">
          <Loader2 className="w-8 h-8 animate-spin text-indigo-600" />
          <p className="text-sm text-gray-600">{loadingText}</p>
          {progress && (
            <div className="w-full max-w-md">
              <div className="mb-4">
                <p className="text-sm text-gray-600 mb-2">Processing transactions...</p>
                <div className="bg-gray-200 rounded-full h-2.5">
                  <div 
                    className="bg-green-600 h-2.5 rounded-full transition-all duration-300"
                    style={{ 
                      width: `${progress.total > 0 
                        ? (progress.current / progress.total) * 100 
                        : 0}%` 
                    }}
                  />
                </div>
                <p className="mt-2 text-xs text-gray-500 text-center">
                  {progress.current.toLocaleString()} of {progress.total.toLocaleString()} transactions processed
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}